import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
} from '@razorpay/blade/components';

interface ErrorInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorInfoModal = ({ isOpen, onClose }: ErrorInfoModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onClose}
      size="small"
      accessibilityLabel="Error information modal">
      <ModalHeader title="Notice an error in your information?" />
      <ModalBody>
        <Box>
          <Text size="medium" color="surface.text.gray.normal">
            If you notice any mistakes in your profile, please contact your HR or Admin team to fix
            them. Keeping your information correct helps avoid problems with your pay and other
            processes.
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" justifyContent="flex-end" width="100%">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
